
import { Box } from "@mui/material";

import { TextareaAutosize } from "@mui/material";
import { useTheme } from "@emotion/react";

import { salesManagement, setupManagementUrl } from "../../../config";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";

import { DiscountRulesQuery} from "../../../data/Axios/queries";
import DiscountTypeForm from "./Form";
import DiscountRuleForm from "./Form";

const base_url = salesManagement.uri;
//const base_url = "https://localhost:7022/graphql/"
const actions = {
  entity: "DiscountRules",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: true,
    permission: "ActivatePermission",
  },
  AssignTask: {
    key: "ASSIGN_TASK",
    button_name: "Assign Task",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2],
  },
  showStatus:true,
};
function DiscountRulesTable() {
const ignore =["appliesToAllCustomers", "appliesToAllProducts", "updateBy"]
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Discount Rules"
          subtitle="Manage Discount Discount"
          ignoreFields={ignore}
          FormComponent={DiscountRuleForm}
          query={DiscountRulesQuery}
          base_url={base_url}
          actions={actions}
        />
      </>
    </Box>
  );
}

export default DiscountRulesTable;